import { forwardRef } from "react"
import type * as Polymorphic from "@radix-ui/react-polymorphic"
import { Property } from "csstype"
import { boxCss } from "../Box"
import { CSS, keyframes, styled, StyleProps, cssHelper } from "../styles"

type LoaderComponent = Polymorphic.ForwardRefComponent<typeof StyledLoader>

export const Loader = forwardRef((props, forwardedRef) => (
  <StyledLoader {...props} ref={forwardedRef} />
)) as LoaderComponent

const scaleIn = keyframes({
  "0%": {
    transform: `scale(0.7)`,
    opacity: 0.3,
  },
  "100%": { opacity: 1 },
})

const scaleOut = keyframes({
  "0%": { opacity: 1 },
  "100%": {
    transform: `scale(0.7)`,
    opacity: 0.3,
  },
})

const getAnimation = (): { animation: unknown } => ({
  animation: cssHelper`${scaleIn} 800ms linear 1 0ms, ${scaleOut} 1600ms linear infinite 400ms`,
})

const getLoaderCss = (props: StyleProps): CSS => ({
  ...boxCss,
  flexGrow: 0,
  display: `flex`,
  margin: `0 auto`,
  width: 50,
  height: 50,
  opacity: 0.3,
  borderRadius: props.theme.borderRadius.round,
  border: `${50 / 10}px solid ${props.theme.palette.brand}`,
  ...(getAnimation() as { animation: Property.Animation }),
})

export const StyledLoader = styled.div((props: StyleProps) => cssHelper`${getLoaderCss(props)}`)
